import { MantineThemeOverride, rem } from '@mantine/core';
import { P2Regular, P3Regular, P4Medium, P4Regular } from 'theme/typography';
import { TABLET_BREAKPOINT } from 'theme/components/utils/tablet';

export type InputWrapperTheme = NonNullable<MantineThemeOverride['components']>['InputWrapper'];

export const InputWrapper: InputWrapperTheme = {
  sizes: {
    lg: () => ({
      label: {
        ...P2Regular,
      },
    }),
    md: (theme) => ({
      label: {
        ...P2Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          ...P3Regular,
        },
      },
    }),
    sm: (theme) => ({
      label: {
        ...P3Regular,
        [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
          ...P4Regular,
        },
      },
    }),
  },
  styles: (theme) => ({
    label: {
      color: theme.colors.gray[6],
      marginBottom: rem(4),
    },
    error: {
      color: theme.colors.red[8],
      ...P4Medium,
    },
  }),
};
